import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { styled } from '@egoist/vue-emotion'
import * as getters from '../../../builder/src/js/store/modules/getters'
import * as actions from '../../../builder/src/js/store/modules/actions'
import * as constants from '../../../builder/src/js/common/constants/constants'
import { mapGetters, mapState, mapActions } from 'vuex'
import CvtButton from '../molecules/Button'
import { GoogleSheetIntegration } from './integrations/google-sheet-integration'
import { HubspotIntegration } from './integrations/hubspot-integration'
import { MailchimpIntegration } from './integrations/mailchimp-integration'

Vue.use(VueI18n)

let textFontWeight, textFontSize, Spacing, FontSize, backgroundColor, Colors

const getLogoContainer = () => styled('p')`
  height: 60px;
  width: 60px;
  margin-right: 18px;
  margin-bottom: 0;
`

const getAuthenticationHeader = () => styled('div')`
  display: flex;
  margin-bottom: 20px;
`

const getSelectedIntegrationTitle = () => styled('p')`
  font-size: 18px;
  margin-bottom: 0;
  color: ${Colors.BASIC[500]};
`

const getSelectedIntegrationCaption = () => styled('p')`
  font-size: 14px;
  margin-bottom: 0;
  color: ${Colors.BASIC[500]};
`

const getAuthenticateWrap = () => styled('div')`
  display: flex;
  width: 85%;
`

const getBackArrowContainer = () => styled('div')`
  margin-right: 30px;
`

export const BuilderIntegrationsAuthTemplate = {
  name: 'BuilderIntegrationsAuthTemplate',
  data() {
    return {}
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters({
      config: getters.AUTH_GET_USER_CONFIG,
      selectedIntegration: getters.SELECTED_INTEGRATION,
    }),
    ...mapGetters('globalTheme', {
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
    }),
    ...mapState('globalTheme', {
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontSize: ({ globalTheme }) => globalTheme.FontSize,
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      globalTheme: ({ globalTheme }) => globalTheme,
    }),
  },
  created() {
    textFontSize = this.textFontSize
    textFontWeight = this.textFontWeight
    Spacing = this.Spacing
    FontSize = this.FontSize
    backgroundColor = this.backgroundColor
    Colors = this.Colors
  },
  mounted() {
    this.onScrollInToView()
  },
  methods: {
    ...mapActions('globalTheme', {}),
    ...mapActions({
      onChangeScreen: actions.UPDATE_INTEGRATIONS_CURRENT_SCREEN,
    }),

    onScrollInToView() {
      const container = document.getElementById('authWrap')
      container.scrollIntoView()
    },

    onStepToIntegrationsScreen() {
      this.onChangeScreen(constants.INTEGRATIONS)
    },
  },
  render: function (h) {
    const AuthenticateWrap = getAuthenticateWrap()
    const BackArrowContainer = getBackArrowContainer()

    const SelectedIntegrationTitle = getSelectedIntegrationTitle()
    const SelectedIntegrationCaption = getSelectedIntegrationCaption()
    const LogoContainer = getLogoContainer()
    const AuthenticationHeader = getAuthenticationHeader()

    const componentMap = {
      googleSheets: GoogleSheetIntegration,
      hubspot: HubspotIntegration,
      mailchimp: MailchimpIntegration,
      // ...otther mappings for integrations
    }

    const Component = componentMap[this.selectedIntegration.key]

    return (
      <AuthenticateWrap id="authWrap">
        <BackArrowContainer>
          <CvtButton
            outlined={true}
            fullWidth={true}
            shape="rounded"
            icon="arrow-left"
            color="light"
            mode="mode"
            text=""
            onClick={this.onStepToIntegrationsScreen}
          />
        </BackArrowContainer>

        <div style="width: 100%;">
          <AuthenticationHeader>
            <LogoContainer>
              <img
                style="height: 100%;"
                src={this.selectedIntegration.image}
                alt="logo"
              />
            </LogoContainer>
            <div>
              <SelectedIntegrationTitle>
                {this.selectedIntegration.title}
              </SelectedIntegrationTitle>
              <SelectedIntegrationCaption>
                Send new contact to your CRM and create new deals.
              </SelectedIntegrationCaption>
            </div>
          </AuthenticationHeader>

          {Component ? <Component /> : null}
        </div>
      </AuthenticateWrap>
    )
  },
}
